/**
 *
 */
export const userPrivacyConfigVivo = {
    template_new_protocol_20230926: `<div style='overflow-x: hidden;'>

    <p style="margin:0pt; orphans:0; text-align:center; widows:0">
        <span style="font-family:Calibri; font-size:14pt; font-weight:bold"> </span>
        <span style="font-family:宋体; font-size:14pt; font-weight:bold">“{{productName}}”</span>
        <span style="font-family:宋体; font-size:14pt; font-weight:bold">隐私政策</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">更新日期：</span>
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">2023</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">年</span>
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">6</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">月</span>
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">25</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">日</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">生效日期：</span>
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">2023</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">年</span>
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">6</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">月</span>
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">25</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">日</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">{{companyFullName}}</span>
        <span style="font-family:宋体; font-size:10.5pt">及其关联方（简称“我们”）作为</span>
        <span style="font-family:宋体; font-size:10.5pt">{{productName}}</span>
        <span
            style="font-family:宋体; font-size:10.5pt">的运营者，深知个人信息对您的重要性，我们将按照法律法规的规定，保护您的个人信息及隐私安全。我们制定本“隐私政策”并特别提示：希望您在使用</span>
        <span style="font-family:宋体; font-size:10.5pt">{{productName}}</span>
        <span style="font-family:宋体; font-size:10.5pt">及相关服务前仔细阅读并理解本隐私政策，以便做出适当的选择。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">本隐私政策将帮助您了解：</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">•
            我们会遵循隐私政策收集、使用您的信息，但不会仅因您同意本隐私政策而采用强制捆绑的方式一揽子收集个人信息。</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">•
            当您使用或开启相关功能或使用服务时，为实现功能、服务所必需，我们会收集、使用相关信息。除非是为实现基本业务功能或根据法律法规要求所必需的必要信息，您均可以拒绝提供且不影响其他功能或服务。我们将在隐私政策中逐项说明哪些是必要信息。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">•
            如果您未登录帐号，我们会通过设备对应的标识符信息来保障信息推送的基本功能。如果您登录了帐号，我们会根据帐号信息实现信息推送。</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">•
            精确地理位置、存储空间权限、使用电话权限，不会默认开启，只有经过您的明示授权才会在为实现特定功能或服务时使用，您也可以撤回授权。</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            特别需要指出的是，即使经过您的授权，我们获得了这些敏感权限，也不会在相关功能或服务不需要时而收集您的信息。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">•
            本隐私政策适用于您通过{{productName}}应用程序来访问和使用我们的产品和服务。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">下文将帮您详细了解我们如何收集、使用、存储、传输、共享、转让（如适用）与保护个人信息；帮您了解查询、访问、删除、更正、撤回授权个人信息的方式。其中，</span>

        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            有关您个人信息权益的条款重要内容我们已用加粗形式提示，请特别关注。
        </span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            1.我们如何收集和使用个人信息
        </span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            2.我们如何使用Cookie等同类技术
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            3.我们如何共享、转让、公开披露个人信息
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            4.我们如何存储个人信息
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            5.我们如何保护个人信息的安全
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            6.管理您的个人信息
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            7.隐私政策的修订和通知
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            8.联系我们
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">1.我们如何收集和使用个人信息</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">我们致力于为你提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。为了维护相关产品或服务的正常稳定运行，保护你或其他用户或公众的安全及合法利益</span>

        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            我们会收集如下必要信息：
        </span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">
            （1）为了保障软件与服务的安全运行、运营的质量及效率，我们会收集你的硬件型号、操作系统版本号、设备标识符（Android如IMEI、AndroidID、OAID、IMSI、ICCID、GAID、MEID，iOS如IDFV、IDFA、SIM卡信息；不同的标识符在有效期、是否可由用户重置以及获取方式方面会有所不同）、网络设备硬件地址（MAC地址）、硬件序列号、SUPI、SUCI、IP
            地址、WLAN接入点（如SSID，BSSID）、蓝牙（Bluetooth）、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志、传感器信息等数据。其次，为检测作弊用户我们还会收集您的软件安装列表，读取您的最近运行任务，这些数据均不会用于反作弊之外的其他服务，请您知悉。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">使用目的及场景：保障软件与服务的安全运行、运营的质量及效率、反作弊检、个性化推荐</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt; font-weight:bold">（2）为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt; font-weight:bold">（3）我们可能使用你的帐号信息、设备信息、服务日志信息，以及我们的关联方、合作方获得你授权或依法可以提供给我们的信息，用于判断帐号安全、交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（4）我们收集您的个人信息会用于定向推送，猜你喜欢等功能。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">（5）此外，我们接入的第三方SDK会收集部分个人信息，主要包括： IMEI、IMSI、设备 MAC 地址、SUPI、SUCI、软件安装列表、位置、联系人、通话记录、日历、短信、本机电话号码、图片、音视频等。具体内容请点击查看旁侧第三方共享清单链接里描述的内容：
            <a data-v-17295723="" href="https://privacyh5.shinet.cn/thirdPage.html">
                <span data-v-17295723="" class="s5"></span>第三方共享清单</span>
        </a>
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">权限说明：</span>
    </p>


    <!-- <table> -->
    <table>

        <!-- <权限说明> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">权限</span>
                </p>
            </td>
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">用途</span>
                </p>
            </td>
        </tr>

        <!-- <1.震动权限> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">1.震动权限
                        android.permission.VIBRATE</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline"> 权限功能说明：使用手机震动权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span
                        style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">使用场景与目的：游戏中的震动场景，游戏震动提示功能需要</span>
                </p>
            </td>
        </tr>

        <!-- <2.读取SD卡内容> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">2.读取手机状态和身份（电话权限、设备权限）
                        android.permission.READ_PHONE_STATE</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：提供读取手机设备标识等信息，请您放心该权限无法监听、获取您的任何通话内容与信息</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span
                        style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">使用场景与目的：读取设备信息、识别设备ID，保障设备安全及唯一设备标识</span>
                </p>
            </td>
        </tr>

        <!-- <3.写入/删除SD卡内容> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span
                        style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">3.写入/删除SD卡内容（写入/删除/存储空间/照片权限）
                        android.permission.WRITE_EXTERNAL_STORAGE</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：提供写入手机外部存储空间内数据的功能</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：允许APP写入存储空间图片、文件等内容，主要用于应用图片缓存以及分享功能</span>
                </p>
            </td>
        </tr>

        <!-- <4.访问大概地理位置信息> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">4.访问大概地理位置信息
                        android.permission.ACCESS_COARSE_LOCATION</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：通过网络位置信息（例如基站和WLAN）获取大致地理位置信息</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：模糊定位，为开发者提供反作弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确，广告sdk需要，用来助于广告投放</span>
                </p>
            </td>
        </tr>

        <!-- <5.访问精确地理位置信息> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">5.访问精确地理位置信息
                        android.permission.ACCESS_FINE_LOCATION</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：通过全球定位系统（GPS）和网络位置信息（例如基站和WLAN）获取精准地理位置信息</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：模糊定位，为开发者提供反作弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确，广告sdk需要，用来助于广告投放</span>
                </p>
            </td>
        </tr>

        <!-- <6.请求使用蓝牙> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">6.请求使用蓝牙
                        android.permission.BLUETOOTH</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：获取手机蓝牙权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：蓝牙权限，为用户使用蓝牙设备时的游戏场景提供便利</span>
                </p>
            </td>
        </tr>

        <!-- <7.获取应用安装列表权限> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">7.获取应用安装列表权限
                        android.permission.REQUEST_INSTALL_PACKAGES</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：获取手机已安装应用列表权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：用于反作弊检测功能以及广告sdk需要（获取已安装应用列表，避免重复安装）</span>
                </p>
            </td>
        </tr>

        <!-- <8.安装应用权限> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">8.安装应用权限
                        android.permission.INSTALL_PACKAGES</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：安装应用权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：安装应用，为广告场景下用户下载提供便利</span>
                </p>
            </td>
        </tr>

        <!-- <9.安装应用权限> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">9.忽略电池优化权限
                        android.permission.REQUEST_IGNORE_BATTERY_OPTIMIZATIONSS</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：请求忽略手机电池优化权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：请求忽略电池优化，保证游戏流畅性</span>
                </p>
            </td>
        </tr>

        <!-- <10.安装应用权限> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">10.网络权限
                        android.permission.INTERNET</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：使用手机网络权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：网络权限，允许应用程序联网和发送请求数据的权限，以便应用提供服务</span>
                </p>
            </td>
        </tr>

        <!-- <11.查询网络权限> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">11.查询网络权限
                        android.permission.ACCESS_NETWORK_STATE</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：查询手机网络权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：查询网络状态，保证用户网络连接状态并在有变更时提供相应服务</span>
                </p>
            </td>
        </tr>

        <!-- <12.查询WIFI状态权限> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">12.查询WIFI状态权限
                        android.permission.ACCESS_NETWORK_STATE</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：查询手机WIFI状态权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：查询WiFi状态，保证网络服务顺畅，判断当前所处环境是否正常、安全，提醒用户开启网络，保证程序正确运行</span>
                </p>
            </td>
        </tr>

        <!-- <13.查询运行任务权限> -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">13.查询运行任务权限
                        android.permission.GET_TASKS</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：获取手机运行中任务列表</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：用于反作弊检测功能以及广告sdk需要（反作弊功能）</span>
                </p>
            </td>
        </tr>

        <!-- <14.运行中任务排序权限 > -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">14.运行中任务排序权限
                        android.permission.REORDER_TASKS</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：对手机运行中任务进行排序权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：排序运行应用列表，对应用排序进行优化</span>
                </p>
            </td>
        </tr>

        <!-- <15.读取手机设置权限 > -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">15.读取手机设置权限
                        android.permission.READ_SETTINGS</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：读取手机系统设置权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：读取系统设置，根据设置提供正确的软件内容</span>
                </p>
            </td>
        </tr>

        <!-- <16.唤醒手机权限 > -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">16.唤醒手机权限
                        android.permission.WAKE_LOCK</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：唤醒手机屏幕权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：游戏场景保持手机设备不息屏及广告sdk需要（避免熄屏）</span>
                </p>
            </td>
        </tr>

        <!-- <17.读取手机应用列表 > -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">17.读取手机应用列表
                        android.permission.QUERY_ALL_PACKAGES</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：获取手机应用列表权限</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：用于反作弊检测功能</span>
                </p>
            </td>
        </tr>

        <!-- <18.读取手机应用列表 > -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">18.获取用户日历数据  
                        android.permission.READ_SETTINGS</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：获取用户日历数据</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：用于有重要通知时方便用户即时创建日历提醒</span>
                </p>
            </td>
        </tr>

        <!-- <19.读取用户日历数据 > -->
        <tr style="display: block;">
            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">19.读取用户日历数据
                        android.permission.WRITE_SETTINGS</span>
                </p>
            </td>

            <td
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width: 40vw; word-break: break-all;">
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        权限功能说明：读取用户日历数据</span>
                </p>
                <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                    <span style="font-family:宋体; font-size:10.5pt; vertical-align:baseline">
                        使用场景与目的：用户体验优化</span>
                </p>
            </td>
        </tr>

    </table>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>


    <!-- <1.1> -->
    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.1</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">注册、登录、认证</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.1.1 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">注册、登录帐号</span>
    </p>

    <!-- <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p> -->

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">当您注册、登录</span>
        <span style="font-family:宋体; font-size:10.5pt">{{productName}}</span>
        <span style="font-family:宋体; font-size:10.5pt">及相关服务时，</span>
        <span style="font-family:宋体; font-size:10.5pt">我们不会收集您的个人信息。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.1.2 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">认证</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体;font-size:10.5pt">{{productName}}选择跳过进行游客登录时，不收集用户个人信息。{{productName}}通过微信登录注册后，不收集用户个人信息进行认证。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>


    <!-- <1.2> -->
    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.2</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">游戏内容体验</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">a.</span>
        <span style="font-family:宋体; font-size:10.5pt">为保障</span>
        <span style="font-family:宋体; font-size:10.5pt">游戏优化和体验</span>
        <span style="font-family:宋体; font-size:10.5pt">，</span>
        <span style="font-family:宋体; font-size:10.5pt">{{productName}}</span>
        <span style="font-family:宋体; font-size:10.5pt">可能会收集相关必要的日志信息。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">b.</span>
        <span style="font-family:宋体; font-size:10.5pt">上述日志信息包括：</span>
        <span style="font-family:宋体; font-size:10.5pt">您操作、使用的行为信息：点击、使用、游戏行为、等级</span>
        <span style="font-family:宋体; font-size:10.5pt">您主动提供的信息</span>
        <span
            style="font-family:宋体; font-size:10.5pt">地理位置信息：含通过GPS信息、WLAN接入点、蓝牙和基站等传感器信息获取到的精确地理位置信息及通过网络位置信息（例如基站、IP及WLAN）获取的大致地理位置信息。</span>
        <span style="font-family:宋体; font-size:10.5pt">电话识别码信息：包含设备硬件型号、操作系统版本号、国际移动设备识别码、唯一设备标识符、网络设备硬件地址。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt; font-weight:bold">c.精确地理位置信息是个人敏感信息，若您拒绝提供，我们将不会根据精确地理位置信息向您推荐信息，且不会影响{{productName}}其他功能的正常使用。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:Calibri; font-size:10.5pt">d.</span>
                <span style="font-family:宋体; font-size:10.5pt">我们会基于大致地理</span>
                <span style="font-family:宋体; font-size:10.5pt">位置</span>
                <span style="font-family:宋体; font-size:10.5pt">信息对应的城市及</span>
                <span style="font-family:Calibri; font-size:10.5pt">/</span>
                <span style="font-family:宋体; font-size:10.5pt">或区县向您展示、推荐您所在地区（城市、区县等）的本地相关信息。</span>
            </p>
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>


    <!-- <1.3> -->
    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.3</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">互动与提现</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt;">
            当用户浏览文章或邀请好友注册时，会获得一定的奖励，用户需要绑定微信或支付宝账号后根据{{productName}}平台的提现规则进行提现。若用户未绑定微信或支付宝账号，将无法实现提现功能。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <!-- <1.4> -->
    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.4</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">信息发布</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt;">用户发布评论、提问或回答时，{{companyShortName}}将收集用户发布的信息，并展示用户的昵称、头像、发布内容。
        </span>
    </p>


    <!-- <1.5> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.5</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">运营与安全运行</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.5.1</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">运营与安全保障</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt;">我们致力于为您提供安全、可信的产品与使用环境，提供优质而可靠的服务与信息是我们的核心目标。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.5.2</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">设备信息与日志信息</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">a.</span>
        <span
            style="font-family:宋体; font-size:10.5pt">为了保障软件与服务的安全运行、运营的质量及效率，我们会收集您的硬件型号、操作系统版本号、国际移动设备识别码、唯一设备标识符、网络设备硬件地址、IP地址、WLAN接入点、蓝牙、基站、软件版本号、网络接入方式、类型、状态、网络质量数据、操作、使用、服务日志。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">b.</span>
        <span
            style="font-family:宋体; font-size:10.5pt">为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用信息或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">c.</span>
        <span
            style="font-family:宋体; font-size:10.5pt">我们可能使用您的账户信息、设备信息、服务日志信息以及我们关联方、合作方在获得您授权或依法可以共享的信息，用于判断账户安全、进行身份验证、检测及防范安全事件。</span>
    </p>

    <!-- <1.6> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.6</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">分享与活动参与</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt;">在您分享或接收被分享的信息、参加活动等情形下，我们需要访问您的剪切板，读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务。
        </span>
    </p>

    <!-- <1.7> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.7</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">统计分析</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt;">为了分析应用新增、激活、留存、性能等统计性指标，我们可能会调用剪切板对相关统计信息进行归因分析，请您放心，我们不会收集您的隐私信息。
        </span>
    </p>


    <!-- <1.8> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.8</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">收集、使用个人信息目的变更</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt;">请您了解，随着我们业务的发展，可能会对{{productName}}的功能和提供的服务有所调整变化。原则上，当新功能或服务与我们当前提供的功能或服务相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原处理目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意
        </span>
    </p>

    <!-- <1.9> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">1.9</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">依法豁免征得同意收集和使用的个人信息</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">a.</span>
        <span style="font-family:宋体; font-size:10.5pt">与国家安全、国防安全直接相关的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">b.</span>
        <span style="font-family:宋体; font-size:10.5pt">与公共安全、公共卫生、重大公共利益直接相关的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">c.</span>
        <span style="font-family:宋体; font-size:10.5pt">与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">d.</span>
        <span style="font-family:宋体; font-size:10.5pt">出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">e.</span>
        <span style="font-family:宋体; font-size:10.5pt">所收集的您的个人信息是您自行向社会公众公开的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">f.</span>
        <span style="font-family:宋体; font-size:10.5pt">从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">g.</span>
        <span style="font-family:宋体; font-size:10.5pt">根据您的要求签订或履行合同所必需的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">h.</span>
        <span style="font-family:宋体; font-size:10.5pt">用于维护软件及相关服务的安全稳定运行所必需的，例如发现、处置软件及相关服务的故障；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">i.</span>
        <span style="font-family:宋体; font-size:10.5pt">为合法的新闻报道所必需的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">j.</span>
        <span
            style="font-family:宋体; font-size:10.5pt">学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">k.</span>
        <span style="font-family:宋体; font-size:10.5pt">法律法规规定的其他情形。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。</span>
    </p>


    <!-- <2> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">2.我们如何使用Cookie等同类技术</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">Cookie
            和设备信息标识等同类技术是互联网中普遍使用的技术。当您使用{{productName}}及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie
            或匿名标识符，以收集、标识您访问、使用本产品时的信息。我们承诺，不会将Cookie 用于本隐私政策所述目的之外的任何其他用途。我们使用Cookie 和同类技术主要为了实现以下功能或服务：</span>
    </p>

    <!-- <2.1> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">2.1</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">保障产品与服务的安全、高效运转</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt;">我们可能会设置认证与保障安全性的Cookie
            或匿名标识符，使我们确认您是否安全登录服务，或者是否遇到盗用、欺诈及其他不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度
        </span>
    </p>

    <!-- <2.2> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">2.2</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">帮助您获得更轻松的访问体验</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt;">使用此类技术可以帮助您省去重复您填写个人信息、输入搜索内容的步骤和流程（示例：记录搜索、表单填写）。</span>
    </p>

    <!-- <2.3> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">2.3</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">为您提供优质游戏内容</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt;">a.我们可能会利用此类技术了解您的偏好和使用习惯，进行数据分析，以改善产品服务、推荐用户感兴趣的信息或功能，并优化您对广告的选择。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt;">b.在{{productName}}的分享页中，我们可能会使用Cookie对浏览活动进行记录，用于向您推荐信息和排查崩溃、延迟的相关异常情况以及探索更好的服务方式。</span>
    </p>

    <!-- <2.4> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">2.4</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold"> Cookie的清除</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt;">大多数浏览器均为用户提供了清除浏览器缓存数据的功能，您可以在浏览器设置功能中进行相应的数据清除操作。如您进行清除，您可能无法使用由我们提供的、依赖于Cookie的服务或相应功能。</span>
    </p>


    <!-- <3> -->
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">3.我们如何共享、转让、公开披露个人信息</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">3.1 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">共享</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">3.1.1 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">共享原则</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">a.</span>
        <span
            style="font-family:宋体; font-size:10.5pt">授权同意原则：未经您的同意，我们不会共享您的个人信息，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果第三方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">b.</span>
        <span style="font-family:宋体; font-size:10.5pt">合法正当与最小必要原则： 共享的数据必须具有合法正当目的，且共享的数据以达成目的必要为限。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">c.</span>
        <span
            style="font-family:宋体; font-size:10.5pt">安全审慎原则：我们将审慎评估第三方使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循合作法律协议。我们会对合作方获取信息的软件工具开发包（SDK）、应用程序接口（API）进行严格的安全监测，以保护数据安全。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">接入第三方SDK目录：
            <a data-v-17295723="" href="https://privacyh5.shinet.cn/thirdPage.html"><span data-v-17295723=""
                    class="s5"></span>第三方共享清单</span></a>
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">为保障本 App 相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件开发包（
            SDK）实现相关目的。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们会对合作方获取信息的软件工具开发包（ SDK）进行严格的安全监测，以保护数据安全。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们对接入的相关第三方 SDK 在目录中列明。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">请注意，第三方 SDK
            可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。
        </span>
    </p>


    

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">广点通SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：用于展示广告</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK提供方：腾讯科技（深圳）有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集目的：提供请求广告信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723=""
            class="s1">SDK收集信息：IMEI、IMSI、ICCID、Android_ID、BSSID、IP地址、设备信息、屏幕参数、MAC设备地址、设备传感器、地理位置信息、软件列表（应用列表），特别说明：该集成SDK会包含其他SDK，腾讯地图SDK、SD卡数据</span>
    </p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">共享方式：本机SDK收集</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK隐私协议：
    <a data-v-17295723="" href="https://www.tencent.com/zh-cn/privacy-policy.html">
                <span data-v-17295723="" class="s5">隐私政策 - Tencent 腾讯</span>
            </a>
    </span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK使用场景：App广告下发、展示</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK敏感权限：位置</span></p>

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>


    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">Android_CN_OAID</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：统计分析，识别唯一设备</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK提供方： github</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集目的：用于识别用户的唯一性，提供更好的服务</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集信息：用户设备唯一码、OAID、应用软件信息、VAID、AAID</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">共享方式：本机SDK收集</span></p>

    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK地址：
    <a data-v-17295723="" href="https://github.com/gzu-liyujiang/Android_CN_OAID">
                <span data-v-17295723="" class="s5">GitHub - gzu-liyujiang/Android_CN_OAID: 安卓设备唯一标识解决方案，可替代移动安全联盟（MSA）统一 SDK 闭源方案。包括国内手机厂商的开放匿名标识（OAID）、海外手机平台的安卓广告标识（AAID），另外也提供了 IMEI/MEID、AndroidID、WidevineID、PseudoID、GUID 等常见的设备标识的获取方法。</span>
            </a>
    </span></p>

    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK使用场景：启动APP同意隐私政策后，App会识别唯一用户</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK敏感权限：应用软件信息</span></p>

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>


    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">BuglySDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：用于应用崩溃、无响应情况的监控和数据分析以便修复bug，优化体验</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723=""
            class="s1">涉及个人信息：设备制造商、设备型号、设备品牌、设备操作系统、设备网络运营商名称、设备ID(deviceId、AndroidId、ICCID、IDFA)</span>
    </p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">App包名及签名信息，或在对应应用商店的APPID</span></p>

    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">应用信息：应用安装列表、运行中的进程信息</span></p>

    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：应用崩溃时</span></p>

    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：深圳市腾讯计算机系统有限公司</span></p>

    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>

    <p data-v-17295723="" class="p3">
        <span data-v-17295723="" class="s4">合作方官网链接：
            <a data-v-17295723="" href="https://bugly.qq.com/">
                <span data-v-17295723=""
                    class="s5">https://bugly.qq.com/</span>
            </a>
        </span>
    </p>
    <p data-v-17295723="" class="p3">
        <span data-v-17295723="" class="s4">合作方隐私政策：
            <a data-v-17295723="" href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">
                <span data-v-17295723=""
                    class="s5">腾讯隐私保护平台</span>
            </a>
        </span>
    </p>
    
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>


    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">火山安全SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备制造商、设备型号、设备品牌、设备操作系统、设备运营商信息、MCC移动国家码、MNC移动网络码、网络访问模式（WIFI状态）、IP地址、CPU信息、系统语言、系统时区、屏幕分辨率、电池电量、设备ID(deviceId、AndroidId、IDFA)及
    App包名及签名信息，或在对应应用商店的APPID</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">应用信息：应用安装列表、运行中的进程信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：反作弊</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：应用启动后业务场景</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：北京火山引擎科技有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3">
        <span data-v-17295723="" class="s4">合作方官网链接：
            <a data-v-17295723="" href="https://www.volcengine.com/">
                <span data-v-17295723=""
                    class="s5">https://www.volcengine.com/</span>
            </a>
        </span>
    </p>
    <p data-v-17295723="" class="p3">
        <span data-v-17295723="" class="s4">合作方隐私政策：
            <a data-v-17295723="" href="https://www.volcengine.com/docs/6600/82955">
                <span data-v-17295723=""
                    class="s5">https://www.volcengine.com/docs/6600/82955</span>
            </a>
        </span>
    </p>    

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>
    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">百度地图 SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备信息【包括设备标识信息（Android如IMEI、MEID、IMSI、Android ID、Serial、ICCID、OAID，iOS如IDFV、IDFA）、系统信息（操作系统版本、设备品牌及型号、设备配置）和运行中的进程信息】 位置信息【可能包括经纬度、GNSS信息、WiFi地址及信号强度信息、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】 网络类型【如移动网络、WiFi网络】</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：统计用户位置分布及推送地理位置相关内容</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：用户观看广告时使用</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：北京百度网讯科技有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：
            <a data-v-17295723="" href="https://lbs.amap.com/"><span data-v-17295723=""
                    class="s5">https://lbs.amap.com/</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：
    <a data-v-17295723="" href="https://lbs.baidu.com/index.php?title=openprivacy"><span data-v-17295723=""
            class="s5">隐私政策 | 百度地图API SDK</span></a></span>
    </p>
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>


    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">短故事SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：为开发者提供短故事浏览的技术服务，保障短故事浏览服务的正常运行并为用户推荐可能感兴趣的短故事内容</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723=""
            class="s1">数据类型：设备品牌、设备型号、操作系统、操作系统api 版本(系统属性)、系统语言、系统时区、屏幕密度、屏幕分辨率、CPU信 息、IDFV、IMEI、IMSI、SUPI、SUCI、MAC 地 址 、MEID、OAID、AndroidID、ICCID、GAID、 硬件序列号、IDFA、IP地 址 、WiFi状
            态、运营商信息、应用版本、应用程序包名、浏览记录、搜索记录、点击记录、分享记录、下载记录、用户隐私设置、用户反馈、用 户模式、用户偏好设置</span>
    </p>
    <p data-v-17295723="" class="p3">
        <span data-v-17295723="" class="s4">官网链接：
            <a data-v-17295723="" href="https://www.csjplatform.com/">
                https://www.csjplatform.com/
            </a>
        </span>
    </p>


    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s3">穿山甲SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：用于展示广告，防止多进程应用的多次初始化</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723=""
            class="s1">设备信息：设备品牌、型号、软件系统版本、分辨率、网络信号强度、IP地址、设备语言、传感器信息、AndroidID无线网SSID名称、WiFi路由器MAC地址及读取wifi扫描结果、设备的MAC地址（如为iOS端，则仅适用于IOS3200以下版本）设备标识符（如IMEI、OAID、IMSI、ICCID、GAID（仅GMS服务）、MEID、设备序列号build_serial，具体字段因软硬件版本不同而存在差异）等基础信息</span>
    </p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">应用信息：开发者应用名、应用包名、版本号、应用前后台状态、运行中的进程信息您可以基于广告投放效果优化的目的需要选择是否向穿山甲提供：【仅Android】应用列表信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">广告信息：对广告的展示、点击及转化等交互数据</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">位置信息：您可以基于广告投放效果优化的目的需要选择是否向穿山甲提供如下信息：位置信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">性能数据：如崩溃数据、性能数据</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">其他信息：运营商信息、设备时区</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：在用户观看广告时使用</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：北京巨量引擎网络技术有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式： SDK采集</span></p>

    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://www.csjplatform.com"><span data-v-17295723=""
                    class="s5">https://www.csjplatform.com</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
    href="https://www.csjplatform.com/privacy/partner"><span data-v-17295723=""
        class="s5">穿山甲广告SDK隐私政策 - 穿山甲广告平台</span></a></span>
    </p>

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s3">优量汇 SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：粗略位置信息 【仅 Android】基站、附近的WIFI、连接的WIFI</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">第三方开发者可以选择是否向本SDK提供如下信息：精确位置信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723=""
            class="s1">设备信息：设备制造商、设备型号、操作系统版本、屏幕分辨率、屏幕方向、屏幕DPI、IP地址、加速度传感器、磁场传感器、陀螺仪、压力传感器等基础信息</span>
    </p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">标识符：OAID、IMEI、Android_ID、IMSI，第三方开发者可以选择是否向本SDK提供如下信息： 【仅Android】 IMEI、Android_ID、IMSI</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">应用信息：宿主应用的包名、版本号、宿主应用的进程名称、运行状态、可疑行为，第三方开发者可以选择是否授权本SDK收集如下信息：应用安装信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用数据：如产品交互数据、广告数据（如展示、点击、转化广告数据）</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">诊断数据：如崩溃数据、性能数据</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：广告投放合作</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：广告推荐</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：深圳市腾讯计算机系统有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>

    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://adnet.qq.com/"><span data-v-17295723=""
                    class="s5">https://adnet.qq.com/</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
    href="https://adnet.qq.com/"><span data-v-17295723=""
        class="s5">腾讯优量汇｜帮助中心</span></a></span>
    </p>

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s3">快手联盟SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：用于展示广告，防止多进程应用的多次初始化</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备标识符（Android如IMEI、AndroidId、IMSI、SN、ICCID、MEID，iOS如IDFV）、SUPI、SUCI、  地理位置信息、MAC地址、用
    户存储空间 (SD 卡数据)、应用进程名称、WLAN接入点</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">基础信息：设备品牌、设备型号、软件系统版本、存储 信息、运营商信息、设备时区、设备语言、网络信息等基础信息 设备标识：IMEI、MEID、OAID、Androidld、IMSl、ICCID 位置信息：IP地址、MAC 地址、GPS 位置信息、基站 信息、WIFI 信息 应用信息：应用安装列表、运行中的进程信息 其他信息：特定类型传感器信息、sim 卡激活信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：用户观看广告时使用</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：北京快手广告有限公司</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://u.kuaishou.com/"><span data-v-17295723=""
                    class="s5">https://u.kuaishou.com/</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">
    合作方隐私政策：<a data-v-17295723=""
                href="https://u.kuaishou.com/home/help/detail/1337/1406"><span data-v-17295723=""
                    class="s5">快手联盟</span></a></span>
    </p>


    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">移动安全联盟SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：收集设备唯一OAID用于保护用户移动信息安全</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备制造商、设备型号、设备品牌、设备网络运营商名称、Android ( IMEI、AndroidId、IMSI、SN、ICCID、MEID  ) 、用户存储空间 (SD 卡数据) 、App包名及签名信息，或在对应应用商店的APPID</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：在标识用户唯一设备时使用</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：中国信息通信研究院</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="http://www.msa-alliance.cn/"><span data-v-17295723=""
                    class="s5">http://www.msa-alliance.cn/</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
    href="https://www.msa-alliance.cn/col.jsp?id=122"><span data-v-17295723=""
        class="s5">移动安全工作委员会</span></a></span>
    </p>    

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">微信 SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：分享服务</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK提供方：腾讯科技（深圳）有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集目的：支持微信授权登录，微信分享</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723=""
            class="s1">SDK收集信息：查看WLAN链接；读取外置存储卡；读取手机状态和身份；写入外部存储卡，读取手机状态和身份，写入外部存储卡；获取软件列表（应用列表）</span>
    </p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">共享方式：本机SDK收集</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK隐私协议：</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK使用场景：微信授权登录，微信分享</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK敏感权限：无</span></p>



    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">百度统计 SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备信息【包括设备标识信息（Android如IMEI、MEID、IMSI、Android ID、Serial、ICCID、OAID、MAC地址，iOS如IDFV、IDFA）、系统信息（操作系统版本、设备品牌及型号、设备配置）和运行中的进程信息】 位置信息【可能包括经纬度、WiFi地址及信号强度信息、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息】 网络类型【如移动网络、WiFi网络】</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：广告投放合作</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：广告合作</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：北京百度网讯科技有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://mtj.baidu.com/web/welcome/login"><span data-v-17295723="" class="s5">
                百度移动统计|移动应用APP统计|android统计分析|iOS统计分析</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
                href="https://tongji.baidu.com/web/help/article?id=330&type=0"><span data-v-17295723="" class="s5">
                百度统计</span></a></span>
    </p>
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">微信开放平台SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：接入微信开放平台，支持微信授权登录、微信分享和微信支付</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">数据类型：设备标识信息 (Android  如： IMEI、AndroidId、IMSI、SN、ICCID、MEID  ) 、用户存储空间 (SD 卡数据) </span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">官网链接：<a data-v-17295723=""
                href="https://open.weixin.qq.com/"><span data-v-17295723="" class="s5">
                https://open.weixin.qq.com/</span></a></span>
    </p>
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">百度定位SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：收集位置信息，防止多进程应用的多次初始化</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">数据类型：地理位置信息、用户存储空间 (SD 卡数据)、应用进程名称 </span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">官网链接：<a data-v-17295723=""
                href="https://lbsyun.baidu.com/"><span data-v-17295723="" class="s5">
                https://lbsyun.baidu.com/</span></a></span>
    </p>

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">百度语音SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备信息【包括设备标识信息（Android如IMEI、MEID、IMSI、Android ID、Serial、ICCID、OAID，iOS如IDFV、IDFA）、系统信息（操作系统版本、设备品牌及型号、设备配置）和运行中的进程信息】 位置信息【可能包括经纬度、GNSS信息、WiFi地址及信号强度信息、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】 网络类型【如移动网络、WiFi网络】</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：语音合成、文字播报</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：录音、语音合成</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：百度（中国）有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://ai.baidu.com/"><span data-v-17295723="" class="s5">
                https://ai.baidu.com/</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
                href="https://ai.baidu.com/ai-doc/SPEECH/Tl9mh38eu"><span data-v-17295723="" class="s5">
                https://ai.baidu.com/ai-doc/SPEECH/Tl9mh38eu</span></a></span>
    </p>

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">com.dreamlin</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备信息【包括设备标识信息（Android如IMEI、MEID、IMSI、Android ID、Serial、ICCID、OAID、IDFA）、系统信息（操作系统版本、设备品牌及型号、设备配置）和运行中的进程信息】 位置信息【可能包括经纬度、GNSS信息、WiFi地址及信号强度信息、WiFi状态、WiFi参数、WiFi列表、基站ID数据信息、运营商信息、设备信号强度信息、IP地址、蓝牙信息和传感器信息（加速度，陀螺仪、方向、压力、旋转矢量、光照、磁力计）】 网络类型【如移动网络、WiFi网络】</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：获取设备信息，用作唯一标识防作弊</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：用户同意之后使用</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：本地工程工具类库</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">com.coohua</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备标识符（Android如IMEI、Android ID、Serial，iOS如IDFV）、MAC地址、WLAN接入点</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">基础信息：设备品牌、设备型号、软件系统版本、存储 信息、运营商信息、设备时区、设备语言、网络信息等基础信息 设备标识：IMEI、MEID、OAID、Androidld、IMSl、ICCID 位置信息：IP地址、MAC 地址、GPS 位置信息、基站 信息、WIFI 信息 应用信息：应用安装列表、运行中的进程信息 其他信息：传感器信息、sim 卡激活信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：广告处理</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：广告播放</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>


    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">创智汇聚广告SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备制造商、设备型号、设备品牌、设备网络运营商名称、App包名及签名信息，或在对应应用商店的APPID</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：收集设备唯一OAID</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：在标识用户唯一设备时使用</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：北京创智汇聚科技股份有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://www.sigmob.com/"><span
                    data-v-17295723="" class="s5">
                    https://www.sigmob.com/
                    </span>
                    </a>
                    </span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
    href="https://www.sigmob.com/policy.html"><span
        data-v-17295723="" class="s5">
        Sigmob移动广告平台
        </span>
        </a>
        </span>
    </p>

    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723="">
    </p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">超级汇川SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备信息，包括：设备品牌、型号、操作系统版本、系统语言、时区、内存大小、屏幕分辨率、网络类型；设备标识符，包括IMEI（仅限部分低版本安卓设备，需开发者调用电话状态权限）、Android ID；广告标识符，包括OAID、CAID、IDFA；应用信息，包括开发者应用名、应用包名、版本号等信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：广告投放、广告监测、广告数据统计、广告流量反作弊</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：广告投放、广告监测、广告数据统计、广告流量反作弊</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：广州爱禾网络技术有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://pixiu-ssp.alibaba.com/#/"><span data-v-17295723="" class="s5">
                超级汇川广告聚合平台</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
    href="https://pixiu-ssp.alibaba.com/privacy_agreement.html"><span data-v-17295723="" class="s5">
    隐私权政策</span></a></span>
    </p>
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">同盾SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：接入同盾SDK,   保护用户隐私</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">数据类型：设备标识信息 (Android  如： IMEI 、AndroidId 、IMSI 、SN 、ICCID 、MEID)  、用户存储空间 (SD 卡数据) </span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">官网链接： <a data-v-17295723=""
                href="https://www.tongdun.cn/"><span data-v-17295723="" class="s5">
                https://www.tongdun.cn/</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">腾讯浏览服务SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：支持移动内容显示</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">数据类型：设备标识信息 (Android  如： IMEI、AndroidId、IMSI、SN、ICCID、MEID)、 用户存储空间 (SD 卡数据)</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">官网链接：<a data-v-17295723=""
                href="https://x5.tencent.com/docs/index.html/"><span data-v-17295723="" class="s5">
                https://x5.tencent.com/docs/index.html/</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">神策SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK提供方：神策网络科技（北京）有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集目的：提供数据分析，数据驱动，改善产品质量，优化用户体验</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集信息：IMEI，OAID，Serial Number，MEID，IMSI，User ID，Android ID，Mac地址，Google Advertising ID，运营商信息， IP地址， 手机Region设置，设备型号，手机电量，手机操作系统版本及语言、加速度传感器、设备传感器</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">共享方式：本机SDK收集</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：App使用时</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK使用场景：APP数据分析</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK敏感权限：无</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://www.sensorsdata.cn/"><span data-v-17295723="" class="s5">
                https://www.sensorsdata.cn/</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">SDK隐私协议：<a data-v-17295723=""
        href="https://manual.sensorsdata.cn/sa/3.0/zh_cn/tech_sdk_client_privacy_policy-22255999.html"><span data-v-17295723="" class="s5">
        神策数据 SDK 隐私声明</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>


    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">友盟SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：统计分析</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK提供方：北京友盟网络科技有限公司</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集目的：为了识别您的设备并预防恶意程序及反作弊，提高服务安全性，保障运营质量及效率，提供数据统计、数据分析服务</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集信息：获取您的IP地址、设备信息（IMEI、MAC、Android_ID、IDFA、OpenUDID、GUID、设备硬件序列号、设备序列号、SIM 卡 IMSI 信息、ICCID、SN个人信息）、设备序列号、运行中的进程信息、已安装APP信息、SD卡数据、OAID、运营商信息、IP地址</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">共享方式：本机SDK收集</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK使用场景：App启动并同意隐私政策后初始化友盟SDK，进行数据统计服务</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK敏感权限：运行中的进程信息、已安装APP信息、OAID、运营商信息、存储、读取手机身份和状态</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">SDK隐私协议：<a data-v-17295723=""
                href="https://www.umeng.com/page/policy"><span data-v-17295723="" class="s5">
                https://www.umeng.com/page/policy</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>


    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">360加固保</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：App异常、性能分析</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK提供方：360固保平台</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集目的：基础加固服务、数据分析服务、盗版监测服务在内的加固安全业务相关的各项功能和服务</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集信息：收集您的设备基础信息，网络信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">共享方式：本机SDK收集</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK使用场景：apk加固需要，提升App安全性</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK敏感权限：无</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">SDK隐私协议：<a data-v-17295723=""
                href="https://jiagu.360.cn/#/global/help/295"><span data-v-17295723="" class="s5">
                三六零天御-企业移动应用安全一站式服务平台</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">梆梆加固保</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：App异常、性能分析</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK提供方：梆梆固保平台</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集目的：基础应用加固、渠道监测、安全评估的加固安全业务相关的各项功能和服务</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集信息：设备基础信息，网络信息、设备传感器</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">共享方式：本机SDK收集</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK使用场景：apk加固需要，提升App安全性</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK敏感权限：无</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">SDK隐私协议：<a data-v-17295723=""
                href="https://passport.bangcle.com/authcenter/users/agreement"><span data-v-17295723="" class="s5">
                梆梆安全 - 防止反编译|APP安全加固|应用加固|盗版监测</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">OKHTTP</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：网络服务</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK提供方：google</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集目的：有效地执行 HTTP 可以使内容加载更快并节省带宽</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集信息：获取服务器的应用页面数据并展示给用户、Android ID</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">共享方式：本机SDK收集</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK使用场景：客户端网络请求</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK敏感权限：无</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">SDK隐私协议：<a data-v-17295723=""
                href="https://www.umeng.com/page/policy"><span data-v-17295723="" class="s5">
                Overview - OkHttp</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">OPPOSDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的： oppo机型适配支持，用于展示广告</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">数据类型：设备标识信息 (Android 如： IMEI、AndroidId、IMSI、SN、ICCID、MEID)  、用户存储空间 (SD 卡数据)、MAC地址</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">官网链接：<a data-v-17295723=""
                href="https://coud.tencent.com/document/product/548/36658/"><span data-v-17295723="" class="s5">
                https://coud.tencent.com/document/product/548/36658/</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>


    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">oppo推送SDK（OPush）</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1"涉及个人信息：RegisterId、应用安装列表等</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1"使用目的：推送服务</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1"使用场景：应用启动后业务场景</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1"收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方主体：<a data-v-17295723=""
                href="https://baike.baidu.com/item/OPPO%E5%B9%BF%E4%B8%9C%E7%A7%BB%E5%8A%A8%E9%80%9A%E4%BF%A1%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/24542973?fromModule=lemma_inlink"><span data-v-17295723="" class="s5">
                OPPO广东移动通信有限公司_百度百科</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://open.oppomobile.com/new/developmentDoc/info?id=11207"><span data-v-17295723="" class="s5">
                OPPO 开放平台-OPPO开发者服务中心</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
                href="https://open.oppomobile.com/new/developmentDoc/info?id=11207"><span data-v-17295723="" class="s5">
                OPPO 开放平台-OPPO开发者服务中心</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">oppo广告联盟</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">涉及个人信息：设备标识符（Android如IMEI、Android ID、Serial，iOS如IDFV）、MAC地址、WLAN接入点</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">基础信息：设备品牌、设备型号、软件系统版本、存储 信息、运营商信息、设备时区、设备语言、网络信息等基础信息 设备标识：IMEI、MEID、OAID、Androidld、IMSl、ICCID 位置信息：IP地址、MAC 地址、GPS 位置信息、基站 信息、WIFI 信息 应用信息：应用安装列表、运行中的进程信息 其他信息：传感器信息、sim 卡激活信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：广告投放</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：应用启动后业务场景</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方主体：<a data-v-17295723=""
    href="https://baike.baidu.com/item/OPPO%E5%B9%BF%E4%B8%9C%E7%A7%BB%E5%8A%A8%E9%80%9A%E4%BF%A1%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/24542973?fromModule=lemma_inlink"><span data-v-17295723="" class="s5">
    OPPO广东移动通信有限公司</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
        href="https://u.oppomobile.com/#/help"><span data-v-17295723="" class="s5">
        OPPO广告联盟</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
        href="https://u.oppomobile.com/#/help"><span data-v-17295723="" class="s5">
        OPPO广告联盟</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>


    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">VIVOSDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的： vivo机型适配支持，用于展示广告</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">数据类型：设备标识信息 (Android 如：IMEI、AndroidId、IMSI、SN、ICCID、MEID) 、用户存储空间 (SD 卡数据)、MAC地址</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4"> 网链接：<a data-v-17295723=""
                href="https://dev.vivo.com.cn/documentCenter/doc/450"><span data-v-17295723="" class="s5">
                https://dev.vivo.com.cn/documentCenter/doc/450</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>


    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">vivo广告联盟</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">设备信息：厂商，型号，系统版本，手机imei，手机android id，设备WIFI网卡MAC地址，ip地址，手机产品序列号，ICCID，MEID，IMSI、Android 10唯一标识符，开发者标识等信息，其中，Android 10唯一标识符，开发者标识仅适用于安卓10以后版本。</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">应用信息：开发者应用名，应用包名，版本号等信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">网络信息：联网方式，运营商等信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">个人位置信息：定位信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：广告投放合作，广告归因，反作弊</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用场景：应用启动后业务场景</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">合作方主体：vivo流量联盟</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">收集方式：SDK采集</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方官网链接：<a data-v-17295723=""
                href="https://adnet.vivo.com.cn/home"><span data-v-17295723="" class="s5">
                vivo广告联盟</span></a></span>
    </p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">合作方隐私政策：<a data-v-17295723=""
        href="https://adnet.vivo.com.cn/home/faq/18"><span data-v-17295723="" class="s5">
        vivo广告联盟</span></a></span>
    </p>
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">华为SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：用于展示广告，防止多进程应用的多次初始化</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">数据类型：设备标识信息 (Android 如： IMEI、AndroidId、IMSI、SN、ICCID、MEID)  、地理位置信息、MAC地址、用户存储空间
    (SD 卡数据)、应用进程名称</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">官网链接：<a data-v-17295723=""
                href="https://developer.huawei.com/consumer/cn/doc/agc-auth-android-integration-SDK-0000001325876845"><span data-v-17295723="" class="s5">
                https://developer.huawei.com/consumer/cn/doc/agc-auth-android-integration-SDK-0000001325876845</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">巨量转化SDK</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">使用目的：用于展示广告，防止多进程应用的多次初始化</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">数据类型：设备标识信息 (Android 如： IMEI、AndroidId、IMSI、SN、ICCID、MEID)、MAC 地址、地理位置信息、用户存储空间
    (SD卡数据)、应用进程名称，软件安装列表</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">官网链接：<a data-v-17295723=""
                href="https://open.oceanengine.com/labels/7/docs/1708428054592516"><span data-v-17295723="" class="s5">
                https://open.oceanengine.com/labels/7/docs/1708428054592516</span></a></span>
    </p>
 
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>
    
    <p data-v-17295723="" class="p2"><span data-v-17295723="" class="s3">百度联盟(网盟)广告</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">第三方类别：广告平台</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK提供方：百度联盟服务商</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集目的：提供请求广告信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK收集信息：ip地址、设备品牌、型号、软件系统版本、分辨率、网络信号强度、磁盘总空间、系统内存空间、屏幕宽高，屏幕像素密度，系统版本号，设备厂商，设备型号，手机运营商、SIM卡信息、手机重启信息、手机系统更新时间、手机系统创建时间、IDFA（仅iOS端采集）、OAID等基础信息、MAC设备地址、IMEI（仅Andriod端采集）、传感器信息、网络状态、地理位置信息、运行中的进程信息</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">共享方式：本机SDK收集</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK使用场景：App广告下发、展示</span></p>
    <p data-v-17295723="" class="p1"><span data-v-17295723="" class="s1">SDK敏感权限：位置</span></p>
    <p data-v-17295723="" class="p3"><span data-v-17295723="" class="s4">SDK隐私协议：<a data-v-17295723=""
                href="https://union.baidu.com/bqt/#/legal/policies"><span data-v-17295723="" class="s5">
                百度联盟</span></a></span>
    </p>
    <p data-v-17295723="" class="p4"><span data-v-17295723="" class="s1"></span><br data-v-17295723=""></p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">权限说明：
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">1.震动权限 android.permission.VIBRATE
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：使用手机震动权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：游戏中的震动场景，游戏震动提示功能需要
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">2.读取手机状态和身份（电话权限、设备权限）android.permission.READ_PHONE_STATE
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：提供读取手机设备标识等信息，请您放心该权限无法监听、获取您的任何通话内容与信息
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：读取设备信息、识别设备ID，保障设备安全及唯一设备标识
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">3.读取SD卡内容（读取存储空间/照片权限） android.permission.READ_EXTERNAL_STORAGE
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：提供读取手机存储空间内数据的功能
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：允许APP读取存储中的图片、文件等内容，主要用于应用图片缓存以及分享功能
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">4.写入/删除SD卡内容（写入/删除/存储空间/照片权限） android.permission.WRITE_EXTERNAL_STORAGE
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：提供写入手机外部存储空间内数据的功能
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：允许APP写入存储空间图片、文件等内容，主要用于应用图片缓存以及分享功能
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">5.访问大概地理位置信息 android.permission.ACCESS_COARSE_LOCATION
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：通过网络位置信息（例如基站和WLAN）获取大致地理位置信息
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：模糊定位，为开发者提供反作弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确，广告SDK需要，用来助于广告投放
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">6.访问精确地理位置信息 android.permission.ACCESS_FINE_LOCATION
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：通过全球定位系统（GPS）和网络位置信息（例如基站和WLAN）获取精准地理位置信息
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：模糊定位，为开发者提供反作弊功能，剔除作弊设备；同时校正用户的地域分布数据，使报表数据更加准确，广告SDK需要，用来助于广告投放
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">7.请求使用蓝牙 android.permission.BLUETOOTH
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：获取手机蓝牙权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：蓝牙权限，为用户使用蓝牙设备时的游戏场景提供便利
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">8.获取应用安装列表权限 android.permission.REQUEST_INSTALL_PACKAGES
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：获取手机已安装应用列表权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：用于反作弊检测功能以及广告SDK需要（获取已安装应用列表，避免重复安装）
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">9.安装应用权限 android.permission.INSTALL_PACKAGES
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：安装应用权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：安装应用，为广告场景下用户下载提供便利
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">10.忽略电池优化权限 android.permission.REQUEST_IGNORE_BATTERY_OPTIMIZATIONSS
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：请求忽略手机电池优化权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：请求忽略电池优化，保证游戏流畅性
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">11.网络权限 android.permission.INTERNET
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：使用手机网络权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：网络权限，允许应用程序联网和发送请求数据的权限，以便应用提供服务
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">12.查询网络权限 android.permission.ACCESS_NETWORK_STATE
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：查询手机网络权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：查询网络状态，保证用户网络连接状态并在有变更时提供相应服务
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">13.查询WIFI状态权限 android.permission.ACCESS_NETWORK_STATE
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：查询手机WIFI状态权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：查询WiFi状态，保证网络服务顺畅，判断当前所处环境是否正常、安全，提醒用户开启网络，保证程序正确运行
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">14.查询运行任务权限 android.permission.GET_TASKS
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：获取手机运行中任务列表
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：用于反作弊检测功能以及广告SDK需要（反作弊功能）
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">15.运行中任务排序权限 android.permission.REORDER_TASKS
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：对手机运行中任务进行排序权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：排序运行应用列表，对应用排序进行优化
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">16.读取手机设置权限 android.permission.READ_SETTINGS
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：读取手机系统设置权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：读取系统设置，根据设置提供正确的软件内容
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">17.唤醒手机权限 android.permission.WAKE_LOCK
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：唤醒手机屏幕权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：游戏场景保持手机设备不息屏及广告SDK需要（避免熄屏）
        </span>
    </p>
        <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:宋体; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
       <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">18.读取手机应用列表 android.permission.QUERY_ALL_PACKAGES
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">权限功能说明：获取手机应用列表权限
        </span>
    </p>
    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt">使用场景与目的：用于反作弊检测功能
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">3.1.2 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">实现功能或服务的共享信息</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">a.当您在使用{{productName}}中由我们的关联方、第三方提供的功能，或者当软件服务提供商、智能设备提供商、系统服务提供商与我们联合为您提供服务时我们会将实现业务所必需的信息与这些关联方、第三方共享，用于综合统计并通过算法做特征与偏好分析，形成间接人群画像，用以向您进行推荐、展示或推送您可能感兴趣的信息，或者推送更适合您的特定功能、服务或商业广告。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">b.登录、使用{{productName}}：您将已持有的{{productName}}帐号及相关信息授权我们同步到{{productName}}后，您将通过同一帐号同时使用{{productName}}的相关服务和功能。有关帐号及信息同步的具体信息可查阅《帐号及信息同步授权协议》。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">c.地理位置服务：当您使用地理位置相关服务时，我们会通过SDK或相关技术将GPS信息与位置服务提供商（百度地图）进行共享以便可以向您返回位置结果。GPS信息是个人敏感信息，拒绝提供，仅会影响地理位置服务功能，但不影响其他功能的正常使用。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">d.为与您使用的终端机型适配消息推送功能，我们可能会通过SDK等技术与终端设备制造商（华为、小米、OPPO、VIVO等）共享手机型号、版本及相关设备信息。</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">3.1.3 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">实现广告相关的共享信息</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">a.广告推送与投放：我们可能与进行推广和广告投放的合作伙伴共享信息，但我们不会共享用于识别您个人身份的信息（姓名、身份证号），仅会向这些合作伙伴提供不能识别您个人身份的间接画像标签及去标识化的设备信息或匿名化后的设备、网络、渠道等信息，以帮助其在不识别您个人身份的前提下提升广告有效触达率。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">b.广告统计：我们可能与业务的服务商、供应商和其他合作伙伴共享分析去标识化的设备信息或统计信息，这些信息难以或无法与您的真实身份相关联。这些信息将帮助我们分析、衡量广告和相关服务的有效性。</span>
    </p>



    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">3.1.4 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">实现安全与分析统计的共享信息</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">a.保障使用安全：我们非常重视帐号、服务及内容安全，为保障您和其他用户的帐号与财产安全，使您和我们的正当合法权益免受不法侵害，我们和关联方或服务提供商可能会共享必要的设备、帐号及日志信息。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">b.分析产品使用情况：为分析我们服务的使用情况，提升用户使用的体验，可能会与关联方或第三方共享产品使用情况（崩溃、闪退）的统计性数据，这些数据难以与其他信息结合识别您的个人身份。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">c.学术研究与科研：为提升相关领域的科研能力，促进科技发展水平，我们在确保数据安全与目的正当的前提下，可能会与科研院所、高校等机构共享去标识化或匿名化的数据。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">3.1.5 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">帮助您参加营销推广活动</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">当您选择参加我们及我们的关联方或第三方举办的有关营销活动时，可能需要您提供姓名、通信地址、联系方式、银行帐号等信息。其中部分信息是个人敏感信息，拒绝提供可能会影响您参加相关活动，但不会影响其他功能。只有经过您的同意，我们才会将这些信息与关联方或第三方共享，以保障您在联合活动中获得体验一致的服务，或委托第三方及时向您兑现奖励。</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">3.2 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">转让</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">a.我们不会转让您的个人信息给任何其他第三方，除非征得您的明确同意。</span>
        <span
            style="font-family:Calibri; font-size:10.5pt">b.随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，您的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所载明的安全标准要求继受方保护您的个人信息，否则我们将要求继受方重新征得您的授权同意。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">3.3 </span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">公开展示</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">a.
            我们不会公开披露您的信息，除非遵循国家法律法规规定或者获得您的同意。我们公开披露您的个人信息会采用符合行业内标准的安全保护措施。</span>
        <span style="font-family:Calibri; font-size:10.5pt">b. 对违规帐号、欺诈行为进行处罚公告时，我们会披露相关帐号的信息。</span>
        <span style="font-family:Calibri; font-size:10.5pt">c.当您授权游戏或小程序后，您和朋友的头像、昵称将会在排名及相关功能中展示。</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">3.4</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">依法豁免征得同意共享、转让、公开披露的个人信息</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span
            style="font-family:宋体; font-size:10.5pt; font-weight:bold">请您理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露您的个人信息无需征得您的授权同意：</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">a.与国家安全、国防安全直接相关的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">b.与公共安全、公共卫生、重大公共利益直接相关的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">c.与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">d.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">e.您自行向社会公众公开的个人信息；</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">f.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">4</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们如何存储个人信息</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">4.1</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">存储地点</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">4.2</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">存储期限</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">我们仅在为提供{{productName}}及服务之目的所必需的期间内保留您的个人信息：您发布的信息、评论、喜欢（点赞）及相关信息，在您未撤回、删除或未注销帐号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">5</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">我们如何保护个人信息的安全</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">a.我们非常重视您个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护您的个人信息，防止您提供的个人信息被不当使用或在未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。目前，{{productName}}已经通过了国家信息安全等级保护（三级）的测评和备案，并通过了国际权威的ISO27001信息安全认证及ISO27701隐私信息管理认证。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">b.我们会使用不低于行业同行的加密技术、匿名化处理及相关合理可行的手段保护您的个人信息，并使用安全保护机制防止您的个人信息遭到恶意攻击。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">c.我们会建立专门的安全部门、安全管理制度、数据安全流程保障您的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问您的个人信息，并适时对数据和技术进行安全审计。</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">d.尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">e.您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的帐号密码及相关个人信息透露给他人等。</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">f.我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止这些安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信及相关形式告知您，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。</span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">g.您一旦离开{{productName}}及相关服务，浏览或使用其他网站、服务及内容资源，我们将没有能力和直接义务保护您在{{productName}}及相关服务之外的软件、网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于{{productName}}的链接或引导。</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">6</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">管理您的个人信息</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的查询、访问、修改、删除、撤回同意授权、注销帐号、投诉举报以及设置隐私功能的相关权利，以使您有能力保障您的隐私和信息安全。</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">6.1</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">改变或撤回授权范围</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">6.1.1</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">改变或撤回敏感权限设置</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">a.您可以在设备本身操作系统中关闭精确 位置地理信息、通讯录、摄像头、麦克风、相册权限、日历权限
            ，改变同意范围或撤回您的授权。撤回授权后我们将不再收集与这些权限相关信息。</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">b.
            当您使用小游戏、小程序后，您可以在小游戏、小程序界面中管理小程序、小游戏获得的应用权限，您可以撤回对小程序、小游戏的应用权限授权。</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">6.1.2</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">改变或撤回授权的信息处理</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">特定的业务功能和服务将需要您的信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响我们此前基于您的授权而开展的个人信息处理。</span>
    </p>


    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">6.2</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">投诉举报</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">您可以按照我们公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，您可以在【我】-【帮助与反馈】，进入用户反馈界面与我们联系。我们核查后会在15日内反馈您的投诉与举报。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">6.3</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">访问隐私政策</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">a.您可以在注册页面，或者在登录个人帐号【我】- 【隐私政策】查看本隐私政策的全部内容。
        </span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">b.请您了解，本隐私政策中所述的{{productName}}及相关服务可能会根据您所使用的手机型号、系统版本、软件应用程序版本、移动客户端等因素而有所不同。最终的产品和服务以您所使用的{{productName}}软件及相关服务为准。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">6.4</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">停止运营向您告知</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">7</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">隐私政策的修订和通知</span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">a.为了给您提供更好的服务，{{productName}}及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，这些修订构成本隐私政策的一部分并具有等同于本隐私政策的效力，未经您明确同意，我们不会削减您依据当前生效的本隐私政策所应享受的权利。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">b.本隐私政策更新后，我们会在{{productName}}发出更新版本，并在更新后的条款生效前通过官方网站（{{officialWebsite}}）公告或其他适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本。
        </span>
    </p>



    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">&#xa0;</span>
    </p>

    <p style="margin:0pt; orphans:0; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt; font-weight:bold">8</span>
        <span style="font-family:宋体; font-size:10.5pt; font-weight:bold">联系我们</span>
    </p>



    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span
            style="font-family:Calibri; font-size:10.5pt">如果用户对用户个人信息等协议条款、“{{productName}}”产品有任何疑问、意见或建议，可通过以下方式联系{{companyShortName}}。
        </span>
    </p>

    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">公司名称：{{companyFullName}}
        </span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">客服邮箱：{{mail}}
        </span>
    </p>


    <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
        <span style="font-family:Calibri; font-size:10.5pt">公司注册地址：{{address}}
        </span>
    </p>





</div>`,
}
